export enum IntegrationPartner {
    dbu = "DBU",
    stack = "stackSports",
    refassist = "refAssist",
    assignr = "assignr",
    knvb = "KNVB",
    refinsight = "refInsight",
    /**
     * YOU MUST ALSO UPDATE DISPLAY NAMES IN:
     * core/src/integrations/IntegrationPartnerDisplayName.ts
     */
}
